import React, { useState } from "react";
import { TIDS } from "@/constants/testIds";

const ROWS = 6;
const COLS = 7;
const empty = () => Array(ROWS).fill(0).map(() => Array(COLS).fill(null));

function checkWinner(g) {
  const dirs = [[0,1],[1,0],[1,1],[1,-1]];
  for (let r=0;r<ROWS;r++) for (let c=0;c<COLS;c++) {
    const v = g[r][c]; if (!v) continue;
    for (const [dr,dc] of dirs) {
      let ok = true;
      for (let k=1;k<4;k++) {
        const nr=r+dr*k, nc=c+dc*k;
        if (nr<0||nr>=ROWS||nc<0||nc>=COLS||g[nr][nc]!==v){ok=false;break;}
      }
      if (ok) return v;
    }
  }
  return null;
}

export default function Connect4({ state, sendState }) {
  const [local, setLocal] = useState({ grid: empty(), turn: "R" });
  const shared = !!sendState && !!state;
  const grid = shared ? (state.grid || empty()) : local.grid;
  const turn = shared ? (state.turn || "R") : local.turn;

  const update = (ng, nt) => {
    if (shared) sendState({ grid: ng, turn: nt });
    else setLocal({ grid: ng, turn: nt });
  };
  const winner = checkWinner(grid);

  const drop = (col) => {
    if (winner) return;
    for (let r=ROWS-1;r>=0;r--) {
      if (!grid[r][col]) {
        const ng = grid.map(row=>row.slice());
        ng[r][col] = turn;
        update(ng, turn === "R" ? "Y" : "R");
        return;
      }
    }
  };
  const reset = () => update(empty(), "R");

  return (
    <div data-testid={TIDS.gameConnect4} className="bg-black/60 border border-white/10 rounded-md p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="sc-heading text-xl font-bold">Connect Four</div>
        <div className="text-xs sc-label">
          {winner ? <span className="text-[#10B981]">Winner: {winner === "R" ? "Red" : "Yellow"}</span> :
            <span>Turn: <span style={{ color: turn === "R" ? "#FF3366" : "#F59E0B" }}>{turn === "R" ? "Red" : "Yellow"}</span></span>}
        </div>
      </div>
      <div className="bg-[#0c0c0e] p-2 rounded-sm inline-block mx-auto block w-fit border border-white/10">
        {grid.map((row, r) => (
          <div key={r} className="flex">
            {row.map((cell, c) => (
              <button
                data-testid={`${TIDS.gameCell}-${r}-${c}`}
                key={c}
                onClick={() => drop(c)}
                className="w-10 h-10 m-0.5 rounded-full border border-white/10 hover:border-[#FF3366]/50 transition"
                style={{ background: cell === "R" ? "#FF3366" : cell === "Y" ? "#F59E0B" : "#18181B" }}
              />
            ))}
          </div>
        ))}
      </div>
      <div className="mt-4 text-center">
        <button data-testid={TIDS.gameReset} onClick={reset} className="sc-btn-ghost text-xs">Reset Game</button>
      </div>
    </div>
  );
}
